import '.a{display:grid;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useTranslations } from '@i18n/useLanguage'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import { pages } from '@app/util/links'
import { labelAddressBuilder } from '@app/util/helpers'

export const HousingFormPageInitiatives = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  return (
    <div className="a c"
      style={{
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      }}
    >
      {housingForm?.initiatives?.map((initiative) => (
        <InitiativeCard
          key={initiative.id}
          to={pages.initiative(initiative.slug)}
          image={initiative.images?.[0]?.src ?? defaultProjectPicture}
          title={initiative.title}
          description={initiative.description}
          location={labelAddressBuilder(
            initiative.location.address,
            t.common.notSpecified,
          )}
          phase={initiative.phase?.name}
          tagText={
            initiative.searchingForMembers
              ? t.common.initiativeStatus.searchingForMembers
              : t.common.initiativeStatus.notSearchingForMembers
          }
          tagVariant={initiative.searchingForMembers ? 'green' : 'gray'}
        />
      ))}
    </div>
  )
}
